<template>
  <v-col class="width">
    <v-card class="elevation-12 degrade-background-sebrae cardzao">
      <div class="sebrae">
        <img
          style="width: 50%"
          src="https://slide1-images.s3.amazonaws.com/public/sebrae-logo.png"
        />
      </div>
      <div class="logo">
        Selo Sebrae de Referência em Atendimento
        <div>Inscrição 2024</div>
      </div>
       <div class="btns">
        <!-- <v-btn
          color="primary"
          @click="$router.push('/formularios/sala-empreendedor')"
          >Sala do Empreendedor</v-btn
        >
        <v-btn color="info" @click="$router.push('/formularios/parceiro')"
          >Parceiros Sebrae</v-btn
        > -->
        <div style="font-weight: bold; font-size: 20px">
          Inscrições encerradas no dia 15/03/2024
        </div>
      </div>
      <div class="cardAqui">
        <div class="medalhas">
          <img
            src="https://slide1-images.s3.amazonaws.com/public/selo-medalha/sombra/seloMedalhaBronzeSombra.png"
          />
          <img
            src="https://slide1-images.s3.amazonaws.com/public/selo-medalha/sombra/seloMedalhaPrataSombra.png"
          />
          <img
            src="https://slide1-images.s3.amazonaws.com/public/selo-medalha/sombra/seloMedalhaOuroSombra.png"
          />
          <img
            src="https://slide1-images.s3.amazonaws.com/public/selo-medalha/sombra/seloMedalhaDiamanteSombra.png"
          />
        </div>
      </div>
    </v-card>
  </v-col>
</template>
<script>
export default {
  data() {
    return {};
  },

  methods: {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
@import "@/variables.scss";

.btns {
  display: flex;
  justify-content: center;
  column-gap: 2rem;
  flex-wrap: wrap;
  row-gap: 10px;

  .v-btn {
    box-shadow: 7px 9px 5px -2px rgba(0, 0, 0, 0.2),
      0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  }
}

.sebrae {
  display: flex;
  justify-content: center;
  margin-top: 6rem;
}

.cardzao {
  min-width: 650px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.width {
  max-width: 650px;
  margin: 0 auto;
  height: 100%;
}

.formulario {
  margin: 0 auto;
  width: 60%;
}

@media screen and (max-width: 770px) {
  .cardzao {
    min-height: 400px;
    min-width: 100%;
  }
  .width {
    max-width: 100%;
    margin: 0;
  }

  .formulario {
    margin: 0 auto;
    width: 90%;
  }
  .medalhas {
    img {
      width: 78px !important;
    }
  }
}

.cardAqui {
  position: relative;
  margin-top: 2rem;
}
.logo {
  text-align: center;

  color: $cor-selo-texto;
  font-size: 24px;
  font-weight: bold;
  padding: 2rem 1rem 1rem 1rem;
  text-align: center;
}

.logoImg {
  width: 350px;
  margin-top: 20px;
}

.medalhas {
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 130px;
  }
}
</style>
